import { useEffect, useState } from "react"
import { Outlet } from "react-router-dom"
import { AppSidebar } from "./app-sidebar"
import { HijackBanner } from "./hijack-banner"
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@/components/ui/sidebar"
import { Button } from "@/components/ui/button"
import { HugeiconsIcon } from "@hugeicons/react"
import { Moon02Icon, Sun02Icon } from "@hugeicons/core-free-icons"
import { GlobalSearchCommand } from "./global-search"
import { SearchButton } from "./search-button"
import { UnitToggle } from "./unit-toggle"
import { ChatIconButton } from "@/features/assistant/components/chat-icon-button"
import { IssueReportPanel } from "@/features/assistant/components/issue-report-panel"
import { StaleDraftNudge } from "@/features/assistant/components/stale-draft-nudge"

function useTheme() {
  const [dark, setDark] = useState(
    () => document.documentElement.classList.contains("dark")
  )

  useEffect(() => {
    if (dark) {
      document.documentElement.classList.add("dark")
      localStorage.setItem("theme", "dark")
    } else {
      document.documentElement.classList.remove("dark")
      localStorage.setItem("theme", "light")
    }
  }, [dark])

  return { dark, toggle: () => setDark((d) => !d) }
}

export function AuthenticatedLayout() {
  const { dark, toggle } = useTheme()

  return (
    <SidebarProvider>
      <AppSidebar />
      {/* Scroll, do not hide. A page that outgrows this box — a wide
          table, a row of cards on a narrow window — is otherwise cut
          off at the right edge with no way to reach the rest of it.
          Card decorations that bleed past their corner are clipped by
          the card itself, so this adds no scrollbar of its own. */}
      <SidebarInset className="min-w-0 overflow-x-auto overflow-y-auto max-h-screen">
        <HijackBanner />
        <header className="sticky top-0 z-10 flex h-12 shrink-0 items-center gap-2 border-b bg-background px-4">
          <SidebarTrigger className="-ml-1 cursor-pointer shrink-0" />
          <span className="hidden text-sm font-medium md:inline truncate shrink-0">
            OMS | Homewood Creations
          </span>
          <span className="text-sm font-semibold md:hidden shrink-0">OMS</span>
          <div className="flex min-w-0 flex-1 justify-center px-2">
            <SearchButton />
          </div>
          <div className="ml-auto flex items-center gap-1 shrink-0">
            <ChatIconButton />
            <UnitToggle />
            <Button variant="ghost" size="icon" className="h-8 w-8 cursor-pointer" onClick={toggle}>
              <HugeiconsIcon icon={dark ? Sun02Icon : Moon02Icon} size={18} />
            </Button>
          </div>
        </header>
        <div className="min-w-0 flex-1 p-6">
          <Outlet />
        </div>
      </SidebarInset>
      <GlobalSearchCommand />
      <IssueReportPanel />
      <StaleDraftNudge />
    </SidebarProvider>
  )
}
